export default __webpack_public_path__ + "static/helclacase1-a155446303c8ceafe525c1de43bbcddb.png";